import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

import {
  KMS_KEY_ARN_VALIDATION_ERROR_MSG,
  QUEUE_ARN_VALIDATION_ERROR_MSG,
  isKmsKeyArn,
  parseQueueArn,
} from "./arn.ts";

export const AwsSqsComponents = InstallSpec({
  "audit-log": ItemComponent({
    type: "string",
    label: "Queue ARN",
    description:
      "Allows P0 to send access events and security findings to an Amazon SQS queue",
    maturity: "beta",
    validator: async (_context: any, id: string) => {
      if (!parseQueueArn(id)) return QUEUE_ARN_VALIDATION_ERROR_MSG;
    },
    schema: {
      kmsKeyArn: Element({
        label: "KMS key ARN",
        type: "string",
        description:
          "Only needed if your queue is encrypted with a customer managed KMS key",
        optional: true,
        step: "new",
        validator: async (_id, field) => {
          if (field?.trim() && !isKmsKeyArn(field))
            return KMS_KEY_ARN_VALIDATION_ERROR_MSG;
        },
      }),
      serviceAccountEmail: Element({
        label: "P0 service account email",
        type: "hidden",
      }),
      serviceAccountId: Element({
        label: "P0 service account ID",
        type: "hidden",
      }),
    },
    maxItems: 1,
  }),
});
